export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_RESET = 'LOGIN_RESET'
export const LOGIN_UPDATE = 'LOGIN_UPDATE'
